import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse} from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AgencySaveREQ, AgencyViewModel, AgentViewModel, InviteAgencyUsersREQ, ToolbarTilesViewModel } from '../../models/wholesaler-api-models';
import { propagateError } from '@program-suite/util-helpers';
@Injectable({
  providedIn: 'root'
})
export class AgencyService {
  http = inject(HttpClient);
  constructor() { }

  async upsertAgency(agency: AgencySaveREQ): Promise<number> {
    try {
      return await firstValueFrom(this.http.post<number>('agency', agency));
    } catch (error) {
      propagateError(error);
      throw new Error('Failed to save agency');
    }
  }

  async inviteUsers(agency: InviteAgencyUsersREQ): Promise<void> {
    try {
      await firstValueFrom(this.http.post<void>('agency/invite-users', agency));
    } catch (error: any) {
      propagateError(error);
      throw new Error('Failed to invite users. Please try again.');
    }
  }

  async getAgency(agencyId: number): Promise<AgencyViewModel> {
    try {
      return await firstValueFrom(this.http.get<AgencyViewModel>(`agency/${agencyId}`));
    } catch (error) {
      propagateError(error);
      throw new Error('Failed to get agency');
    }
  }
  
  async getAgent(agentId: number): Promise<AgentViewModel> {
    try {
      return await firstValueFrom(this.http.get<AgentViewModel>(`agency/agent/${agentId}`));
    } catch (error) {
      propagateError(error);
      throw new Error('Failed to get agent');
    }
  }

  async updateAgent(agent: AgentViewModel): Promise<void> {
    try {
      await firstValueFrom(this.http.put<void>('agency/agent', agent));
    } catch (error) {
      propagateError(error);
      throw new Error('Failed to update agent');
    }
  }

  async resendInvite(userInviteGuid: string): Promise<void> {
    try {
      await firstValueFrom(this.http.post<void>(`agency/resend-agency-invite/${userInviteGuid}`, null));
    } catch (error: any) {
      propagateError(error);
      throw new Error('Failed to resend invite. Please try again.');
    }
  }

  async cancelInvite(userInviteGuid: string): Promise<void> {
    try {
      await firstValueFrom(this.http.post<void>(`agency/cancel-invite/${userInviteGuid}`, null));
    } catch (error: any) {
      propagateError(error);
      throw new Error('Failed to cancel invite. Please try again.');
    }
  }

  async getAgencyToolbar(agencyId: number): Promise<ToolbarTilesViewModel> {
    try {
      return await firstValueFrom(this.http.get<ToolbarTilesViewModel>(`agency/agency-toolbar/${agencyId}`));
    } catch (error) {
      propagateError(error);
      throw new Error('Failed to get agency toolbar tiles');
    }
  }
}